import { apiCall } from './gqlClient';

const WORKOUTPLANS_QUERY = `
  query workoutPlans($providerId: Float) {
    workoutPlans(providerId: $providerId)
    {
      id
			providerId
			title
			description
			imageId
			imageUrl
			dateCreated
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			goalType
			equipmentContext
			tier
			generation
			schedule
			nutritionPlanId
			programming
      ...fragments
    }
  }`;

export const workoutPlansApiCall = async ({providerId}, fragments = null) => apiCall({ query: WORKOUTPLANS_QUERY, variables: {providerId}, fragments });

const WORKOUTPLAN_QUERY = `
  query workoutPlan($id: String!) {
    workoutPlan(id: $id)
    {
      id
			providerId
			title
			description
			imageId
			imageUrl
			dateCreated
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			goalType
			equipmentContext
			tier
			generation
			schedule
			nutritionPlanId
			programming
      ...fragments
    }
  }`;

export const workoutPlanApiCall = async ({id}, fragments = null) => apiCall({ query: WORKOUTPLAN_QUERY, variables: {id}, fragments });

const ARCHIVEDWORKOUTPLANS_QUERY = `
  query archivedWorkoutPlans($providerId: Float!) {
    archivedWorkoutPlans(providerId: $providerId)
    {
      id
			providerId
			title
			description
			imageId
			imageUrl
			dateCreated
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			goalType
			equipmentContext
			tier
			generation
			schedule
			nutritionPlanId
			programming
      ...fragments
    }
  }`;

export const archivedWorkoutPlansApiCall = async ({providerId}, fragments = null) => apiCall({ query: ARCHIVEDWORKOUTPLANS_QUERY, variables: {providerId}, fragments });

const TEMPLATES_QUERY = `
  query templates($tier: WorkoutPlanTier, $goalType: GoalType, $equipmentContext: EquipmentContext) {
    templates(tier: $tier, goalType: $goalType, equipmentContext: $equipmentContext)
    {
      id
			providerId
			title
			description
			imageId
			imageUrl
			dateCreated
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			goalType
			equipmentContext
			tier
			generation
			schedule
			nutritionPlanId
			programming
      ...fragments
    }
  }`;

export const templatesApiCall = async ({tier, goalType, equipmentContext}, fragments = null) => apiCall({ query: TEMPLATES_QUERY, variables: {tier, goalType, equipmentContext}, fragments });

const WORKOUTPLANSCHEDULES_QUERY = `
  query workoutPlanSchedules($workoutPlanId: String!) {
    workoutPlanSchedules(workoutPlanId: $workoutPlanId)
    {
      id
			workoutPlanId
			workoutId
			workoutTimeFrom
			workoutTimeTo
			workoutOrder
			workoutSchedule
      ...fragments
    }
  }`;

export const workoutPlanSchedulesApiCall = async ({workoutPlanId}, fragments = null) => apiCall({ query: WORKOUTPLANSCHEDULES_QUERY, variables: {workoutPlanId}, fragments });

const USERWORKOUTPLANS_QUERY = `
  query userWorkoutPlans($userId: Float!) {
    userWorkoutPlans(userId: $userId)
    {
      id
			userId
			workoutPlanId
			startTime
			numberOfWeeks
			price
			active
			endTime
			groupId
			orderId
      ...fragments
    }
  }`;

export const userWorkoutPlansApiCall = async ({userId}, fragments = null) => apiCall({ query: USERWORKOUTPLANS_QUERY, variables: {userId}, fragments });

const USERWORKOUTPROGRESSLIST_QUERY = `
  query userWorkoutProgressList($userId: Float!) {
    userWorkoutProgressList(userId: $userId)
    {
      id
			userId
			workoutId
			userPlanId
			dateCreated
			duration
			totalPercentage
			providerId
			progress
			note
			rating
			groupId
      ...fragments
    }
  }`;

export const userWorkoutProgressListApiCall = async ({userId}, fragments = null) => apiCall({ query: USERWORKOUTPROGRESSLIST_QUERY, variables: {userId}, fragments });

const CREATEWORKOUTPLAN_QUERY = `
  mutation createWorkoutPlan($input: WorkoutPlanInput!) {
    createWorkoutPlan(input: $input)
    {
      id
			providerId
			title
			description
			imageId
			imageUrl
			dateCreated
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			goalType
			equipmentContext
			tier
			generation
			schedule
			nutritionPlanId
			programming
      ...fragments
    }
  }`;

export const createWorkoutPlanApiCall = async ({input}, fragments = null) => apiCall({ query: CREATEWORKOUTPLAN_QUERY, variables: {input}, fragments });

const DUPLICATEWORKOUTPLAN_QUERY = `
  mutation duplicateWorkoutPlan($id: String!) {
    duplicateWorkoutPlan(id: $id)
    {
      id
			providerId
			title
			description
			imageId
			imageUrl
			dateCreated
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			goalType
			equipmentContext
			tier
			generation
			schedule
			nutritionPlanId
			programming
      ...fragments
    }
  }`;

export const duplicateWorkoutPlanApiCall = async ({id}, fragments = null) => apiCall({ query: DUPLICATEWORKOUTPLAN_QUERY, variables: {id}, fragments });

const UPDATEWORKOUTPLAN_QUERY = `
  mutation updateWorkoutPlan($id: String!, $input: WorkoutPlanInput!) {
    updateWorkoutPlan(id: $id, input: $input)
    {
      id
			providerId
			title
			description
			imageId
			imageUrl
			dateCreated
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			goalType
			equipmentContext
			tier
			generation
			schedule
			nutritionPlanId
			programming
      ...fragments
    }
  }`;

export const updateWorkoutPlanApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATEWORKOUTPLAN_QUERY, variables: {id, input}, fragments });

const DELETEWORKOUTPLAN_QUERY = `
  mutation deleteWorkoutPlan($id: String!) {
    deleteWorkoutPlan(id: $id)
    {
      id
			providerId
			title
			description
			imageId
			imageUrl
			dateCreated
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			goalType
			equipmentContext
			tier
			generation
			schedule
			nutritionPlanId
			programming
      ...fragments
    }
  }`;

export const deleteWorkoutPlanApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEWORKOUTPLAN_QUERY, variables: {id}, fragments });

const ARCHIVEWORKOUTPLAN_QUERY = `
  mutation archiveWorkoutPlan($id: String!) {
    archiveWorkoutPlan(id: $id)
    {
      id
			providerId
			title
			description
			imageId
			imageUrl
			dateCreated
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			goalType
			equipmentContext
			tier
			generation
			schedule
			nutritionPlanId
			programming
      ...fragments
    }
  }`;

export const archiveWorkoutPlanApiCall = async ({id}, fragments = null) => apiCall({ query: ARCHIVEWORKOUTPLAN_QUERY, variables: {id}, fragments });

const RESTOREWORKOUTPLAN_QUERY = `
  mutation restoreWorkoutPlan($id: String!) {
    restoreWorkoutPlan(id: $id)
    {
      id
			providerId
			title
			description
			imageId
			imageUrl
			dateCreated
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			goalType
			equipmentContext
			tier
			generation
			schedule
			nutritionPlanId
			programming
      ...fragments
    }
  }`;

export const restoreWorkoutPlanApiCall = async ({id}, fragments = null) => apiCall({ query: RESTOREWORKOUTPLAN_QUERY, variables: {id}, fragments });

const CREATEWORKOUTPLANSCHEDULE_QUERY = `
  mutation createWorkoutPlanSchedule($input: WorkoutPlanScheduleInput!) {
    createWorkoutPlanSchedule(input: $input)
    {
      id
			workoutPlanId
			workoutId
			workoutTimeFrom
			workoutTimeTo
			workoutOrder
			workoutSchedule
      ...fragments
    }
  }`;

export const createWorkoutPlanScheduleApiCall = async ({input}, fragments = null) => apiCall({ query: CREATEWORKOUTPLANSCHEDULE_QUERY, variables: {input}, fragments });

const DELETEWORKOUTPLANSCHEDULE_QUERY = `
  mutation deleteWorkoutPlanSchedule($id: String!) {
    deleteWorkoutPlanSchedule(id: $id)
    {
      id
			workoutPlanId
			workoutId
			workoutTimeFrom
			workoutTimeTo
			workoutOrder
			workoutSchedule
      ...fragments
    }
  }`;

export const deleteWorkoutPlanScheduleApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEWORKOUTPLANSCHEDULE_QUERY, variables: {id}, fragments });

const CREATEUSERWORKOUTPROGRESS_QUERY = `
  mutation createUserWorkoutProgress($input: UserWorkoutProgressInput!) {
    createUserWorkoutProgress(input: $input)
    {
      id
			userId
			workoutId
			userPlanId
			dateCreated
			duration
			totalPercentage
			providerId
			progress
			note
			rating
			groupId
      ...fragments
    }
  }`;

export const createUserWorkoutProgressApiCall = async ({input}, fragments = null) => apiCall({ query: CREATEUSERWORKOUTPROGRESS_QUERY, variables: {input}, fragments });
